// Fancybox voor core WordPress gallery blocks (.wp-block-gallery).
// Tagt elke afbeelding in het block met [data-fancybox], zodat de generieke
// Fancybox.bind("[data-fancybox]") in main.js hem oppakt. Werkt voor zowel het
// nieuwe figure-gebaseerde block (WP 5.9+) als de oude ul.blocks-gallery-grid.
export function initWpBlockGallery() {
    const galleries = document.querySelectorAll(".wp-block-gallery");

    galleries.forEach((gallery, index) => {
        if (gallery.dataset.fancyboxInit === "1") return;
        gallery.dataset.fancyboxInit = "1";

        const group = `wp-gallery-${index}`;
        const images = gallery.querySelectorAll("img");

        images.forEach((img) => {
            const figure = img.closest("figure");
            const caption = figure?.querySelector("figcaption")?.textContent.trim() || img.alt || "";
            const full = getFullSizeUrl(img);

            let link = img.closest("a");

            if (link) {
                // "Link naar mediabestand" staat aan: gebruik de bestaande link.
                if (!isImageUrl(link.getAttribute("href"))) {
                    // Link gaat naar een pagina/attachment, niet naar het bestand zelf.
                    link.setAttribute("data-src", full);
                }
            } else {
                // Geen link: wrap de img zodat er iets klikbaars is.
                link = document.createElement("a");
                link.href = full;
                img.replaceWith(link);
                link.appendChild(img);
            }

            link.setAttribute("data-fancybox", group);
            link.setAttribute("data-type", "image");
            if (caption && !link.hasAttribute("data-caption")) {
                link.setAttribute("data-caption", caption);
            }
        });
    });
}

function getFullSizeUrl(img) {
    // Oud gallery block (v1) zet de originele url in data-full-url.
    if (img.dataset.fullUrl) return img.dataset.fullUrl;

    // Grootste kandidaat uit srcset.
    const srcset = img.getAttribute("srcset");
    if (srcset) {
        let best = null;
        srcset.split(",").forEach((entry) => {
            const [url, descriptor] = entry.trim().split(/\s+/);
            const width = parseInt(descriptor, 10) || 0;
            if (!best || width > best.width) best = { url, width };
        });
        if (best?.url) return best.url;
    }

    // Anders: strip het -WIDTHxHEIGHT formaat-suffix van de src.
    const src = img.currentSrc || img.src;
    return src.replace(/-\d+x\d+(?=\.[a-z0-9]+(?:\?.*)?$)/i, "");
}

function isImageUrl(url) {
    return /\.(jpe?g|png|gif|webp|avif|svg)(?:\?.*)?$/i.test(url || "");
}
